var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-1 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "chat"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    id: "Vivid.JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vivid-Icons",
    transform: "translate(-668.000000, -409.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(37.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat",
    transform: "translate(624.000000, 234.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000, 6.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,31.765 C13.4557046,31.857522 9.95909276,30.9327036 6.924,29.1 L0,36 L0,15.882 L0.012,15.888 C0.011,15.791 0,15.7 0,15.6 C0,6.369 6.247,0 17,0 C27.753,0 34,6.652 34,15.882 C34,25.112 27.753,31.765 17,31.765 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.994,12.99 C26.6508542,12.99 27.994,14.3331458 27.994,15.99 C27.994,17.6468542 26.6508542,18.99 24.994,18.99 C23.3371458,18.99 21.994,17.6468542 21.994,15.99 C21.994,14.3331458 23.3371458,12.99 24.994,12.99 Z M17,13 C18.6568542,13 20,14.3431458 20,16 C20,17.6568542 18.6568542,19 17,19 C15.3431458,19 14,17.6568542 14,16 C14,14.3431458 15.3431458,13 17,13 Z M9,13 C10.6568542,13 12,14.3431458 12,16 C12,17.6568542 10.6568542,19 9,19 C7.34314575,19 6,17.6568542 6,16 C6,14.3431458 7.34314575,13 9,13 Z",
    fill: "#ffffff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.d47c16d0de0fde16a49fe31eb0f962bc.svg";
export { ForwardRef as ReactComponent };